import { render, staticRenderFns } from "./SingleStat.vue?vue&type=template&id=029d53fe"
import script from "./SingleStat.vue?vue&type=script&lang=js"
export * from "./SingleStat.vue?vue&type=script&lang=js"
import style0 from "./SingleStat.vue?vue&type=style&index=0&id=029d53fe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports